export enum TableColumnFormatsEnum {
    date
}
